import React from 'react';
import { useRouter } from 'next/router';
import { useFilters } from '../useFilters';

interface Props {
	filterKey: string;
}

export const useApplyFilterMultiple = ({ filterKey }: Props) => {
	const router = useRouter();
	const [selected, setSelected] = React.useState<string[]>([]);
	const { hasFilter, setParamFilter } = useFilters();

	const handleSelectFilters = (value?: string): void => {
		if (value) {
			const newSelected = selected.includes(value)
				? selected.filter((s) => s !== value)
				: [...selected, value];
			setParamFilter(filterKey, newSelected.join(','));
		}
	};

	const handleClearAll = (): void => {
		setParamFilter(filterKey, '');
		setSelected([]);
	};

	React.useEffect(() => {
		const queryParam = router.query[filterKey] as string;
		if (queryParam) {
			const value = queryParam.split(',');
			setSelected(value);
		} else {
			setSelected([]);
		}
	}, [router.query]);

	return {
		handleSelectFilters,
		handleClearAll,
		hasFilter,
		selected,
	};
};
